import {toast, ToastOptions} from 'react-toastify';

type NotificationType = 'info' | 'success' | 'error' | 'warning' | 'default';

const Notification = (msg: string, type: NotificationType = 'default') => {
  const timeout = import.meta.env.VITE_NOTIFY_TIMEOUT;
  const options: ToastOptions = {
    autoClose: timeout ? parseInt(timeout, 10) : 3000
  };
  switch (type) {
    case 'warning':
      toast.warning(msg, options);
      break;
    case 'info':
      toast.info(msg, options);
      break;
    case 'success':
      toast.success(msg, options);
      break;
    case 'error':
      toast.error(msg, options);
      break;
    default:
      toast(msg, options);
  }
};

export default Notification;
